import api from "./api";

export const getAllDownloadDocuments = (language) =>
  api.get(`/downloads/documents?language=${language}`);

export const getDocument = async (familyId, documentId) => {
  return api.get(`/downloads/downloaddocument/${familyId}/${documentId}`, {
    responseType: "blob",
  });
};
